import * as React from 'react'
import * as Tgcc from '../../tgccGlobal'
import { CSSProperties } from 'react'
import { ShopItemCloseUpInAdd } from './ShopItemCloseupInAdd'
import { ShopCloseX } from './ShopCloseX'

const wrapperStyle: CSSProperties = {
    position: 'fixed',
    top: '0px',
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#a9a9a9A1',
    zIndex: 88,
}
const containerStyle: React.CSSProperties = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    display: 'flex',
    alignSelf: 'flex-stretch',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    overflowY: 'scroll',
    maxWidth: '350px',
    zIndex: 99
}
const addToCartStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '0px',
    right: '0px',
    zIndex: 999,
    color: '#676767',
    background: 'white',
    padding: '10px',
    height: '800px'
}
const closeButtonStyle: React.CSSProperties = {
    position: 'relative',
    right: 0,
    top: 0,
    height: '30px',
    width: '30px',
    backgroundColor: 'white',
    '&::after': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        content: 'X',
        fontSize: '50px',
        color: '#FFF',
        lineHeight: '30px',
        textAlign: 'center'
    }
}
const itemTextStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-start',
    color: 'darkgray',
    fontSize: '15px',
    lineHeight: '28px'
}
const itemNumberStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-start',
    fontSize: '18px',
    lineHeight: '35px',
    paddingTop: '5px'
}
const itemPriceStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-start',
    color: 'black',
    fontSize: '18px',
}
const summaryTextStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-start',
    fontSize: '12px',
    color: 'darkblue',
    marginTop: '10px'
}
const itemImageStyle: React.CSSProperties = {
    width: '300px',
    marginBottom: '10px',
    cursor: 'pointer'
}
const sizeListStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    paddingLeft: '10px'
}
const sizeButtonStyle: React.CSSProperties = {
    margin: '2px',
    width: '40px',
    height: '30px',
    lineHeight: '30px',
    textAlign: 'center',
    color: 'rgba(67,67,67,1)',
    border: '1px solid darkgray',
    backgroundColor: 'white',
    '&:hover': {
        backgroundColor: 'lightgray',
    }
}
const szTextStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
}
const buttonGrpStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'space-around',
    justifyContent: 'center'
}
const buttonStyle: CSSProperties = {
    color: 'black',
    width: '100px',
    height: '30px',
    lineHeight: '30px',
    margin: '15px',
    textAlign: 'center',
    cursor: 'pointer',
    border: '1px solid black',
    backgroundColor: 'white',
    '&:hover': {
        backgroundColor: 'lightgray',
    }
}
const labeledControlStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '10px'
}
const qtySelectStyle: CSSProperties = {
    border: '1px solid black',
    marginLeft: '3px',
    textAlign: 'right'
}

var errorStyle = Object.assign({}, Tgcc.Styles.error, { fontSize: '20px', marginBottom: '5px' });

class StateType {
    isWaiting: boolean;
    error: string;
    addSize: string;
    quantity: number;
    showCloseUp: boolean;
}
class AddToCartProps {
    item: Tgcc.WebStoreItem;
    cart: Tgcc.WebStoreCart;
    addCallback: (item: Tgcc.WebStoreItem, qty: number, sz: string) => void;
    goToCartCallback: () => void;
    closeCallback: (evt) => void;
}
export class ShopAddToCart extends React.Component<AddToCartProps, any>{
    state: StateType = {
        isWaiting: false,
        error: null,
        addSize: this.props.item.sizes.length > 0 ? this.props.item.sizes[0] : null,
        quantity: 1,
        showCloseUp: false
    };

    gotoCartVisible = boolean => this.props.cart.items.length ? "visible" : "hidden"

    getSizeButton = (sz: string) => {
        var btnStyle = Object.assign({}, sizeButtonStyle);
        if (this.state.addSize == sz) {
            btnStyle.border = '2px solid black';
        }
        return (<button type="button" key={"szButton" + sz} style={btnStyle} onClick={(evt) => this.addingSize(sz)}>{sz}</button>)
    }

    addingSize = (sz: string) => this.setState({ addSize: sz, error: null });

    clearAddSize = () => this.setState({ addSize: null });

    getSizeButtons = () => {
        var szButtons = []
        this.props.item.sizes.forEach((sz) => {
            // no button for One Size
            if (sz != "OSFM")
                szButtons.push(this.getSizeButton(sz));
        });
        return szButtons;
    }

    sizeLabels: any = {
        'YXS': 'Youth XS',
        'YS': 'Youth Sm',
        'YM': 'Youth Med',
        'YL': 'Youth Lg',
        'YXL': 'Youth XL',
        'XS': 'XS',
        'SM': 'Small',
        'M': 'Medium',
        'LG': 'Large',
        'XL': 'XL',
        'XXL': 'XXL',
        '3XL': '3XL',
        '4XL': '4XL',
        '5XL': '5XL',
        '6XL': '6XL',
        'T2': '2T',
        'T3': '3T',
        'T4': '4T',
        'T5': '5T',
        'T6': '6T',
        'T7': '7T',
        '6mo': "6m",
        '12mo': "12m",
        '18mo': "19m",
        '24mo': "24m",
        'OSFM': "One Size"
    };

    getAddSummary = (): string => {
        var cartCt: number = 0;
        this.props.cart.items.forEach((item: Tgcc.WebStoreCartItem) => {
            if (this.props.item.id == item.id) {
                if (!this.state.addSize)
                    cartCt += item.quantity;
                else if (this.state.addSize == item.size)
                    cartCt += item.quantity;
            }
        });

        var sizeLabel: string = this.state.addSize ? this.sizeLabels[this.state.addSize] : 'of this item';
        return 'You currently have ' + +cartCt + ' ' + sizeLabel + ' in your cart.'
    }
    setCount = (evt: any) => {
        var qty: number = parseInt(evt.currentTarget.value);
        this.setState({ quantity: qty, error: null });
    }
    addToCart = () => {
        if (this.props.item.sizes.length == 0 || this.state.addSize)
            this.props.addCallback(this.props.item, this.state.quantity, this.state.addSize ?? "OSFM");
        else
            this.setState({ error: "Please select size" });
    }
    gotoCart = () => {
        this.props.goToCartCallback()
    }
    checkClose = (evt: any) => {
        if (evt.target.id == 'screendoor')
            this.props.closeCallback(evt);
    }

    showItemCloseUp = (evt: any) => this.setState({ showCloseUp: true });
    clearPopup = (evt: any) => this.setState({ showCloseUp: false });

    render() {
        var imgPath = Tgcc.getProofPath(this.props.item.tBanker.proofId);
        var sizeButtons = this.getSizeButtons();
        var sizeText = sizeButtons.length ? "Sizes:" : "One size fits most";
        var errorMsg = this.state.error ? <div>{this.state.error}</div> : <div />
        var closeUp = this.state.showCloseUp ? <ShopItemCloseUpInAdd proofId={this.props.item.tBanker.proofId} clearStateCallback={this.clearPopup} /> : <div></div>;
        var gotoCartBtnStyle = Object.assign({}, buttonStyle);
        gotoCartBtnStyle.visibility = this.gotoCartVisible ? "visible" : "hidden";
        return (
            <div id="screendoor" style={wrapperStyle} onClick={this.checkClose}>
                {closeUp}
                <div key="addToCartContainer" style={containerStyle}>
                    <div key="addToCart" style={addToCartStyle} className="addToCart">
                        <ShopCloseX key="closeX" closeAction={this.props.closeCallback} top='-8px' right='2px' />
                        <div key="itemnum" style={itemNumberStyle}>{this.props.item.tBanker.proofId}</div>
                        <div key="itemname" style={itemTextStyle}>{this.props.item.productBrand} - {this.props.item.productColor}</div>
                        <div key="itemprice" style={itemPriceStyle}>${this.props.item.tBanker.price}</div>
                        <img key="itemimage" alt="item image" src={imgPath} style={itemImageStyle} onClick={this.showItemCloseUp} />
                        <div key="sizeslabel" style={itemTextStyle}>{sizeText}</div>
                        <div key="sizelist" style={sizeListStyle}>
                            {sizeButtons}
                        </div>
                        <div key="qtyGroup" style={labeledControlStyle}>
                            <div key="qtyLabel" style={itemTextStyle}>Quantity:</div>
                            <input type="number" name="qtySelect" style={qtySelectStyle} onChange={this.setCount} min="1" max="99" value={this.state.quantity} />
                        </div>
                        <div key="addsummary" style={summaryTextStyle} >{this.getAddSummary()}</div>
                        {errorMsg}
                        <div style={buttonGrpStyle}>
                            <button type="button" style={buttonStyle} onClick={this.addToCart}>Add to Cart</button>
                            <button type="button" style={gotoCartBtnStyle} onClick={this.gotoCart}>View Cart</button>
                        </div>
                    </div>
                </div>
            </div>);
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { state: state };
};
